
import { createSelector } from "reselect";

const selectRegistryState = (state) => state.registry;

export const selectMyParticipant = createSelector(selectRegistryState, (state) => state.myParticipant);

export const selectTemplates = createSelector(selectRegistryState, (state) => state.templates);
